import React, { Component } from "react";
import {
  PageHeader,
  Tag,
  Button,
  Statistic,
  Row,
  Col,
  Dropdown,
  Menu,
  Table,
  Input,
  Space,
  Spin,
  DatePicker,
  Form,
  Select
} from "antd";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { GET, DELETE, UPDATE } from "../constants/request-type";
import { service_api } from "../constants/url";
import {
  order,
  delete_order,
  update_order,
  get_all_order,
  user,
  get_all_user,
  food,
  get_all_food
} from "../constants/routes";
import { MakeRequestAsync } from "../functions/axios";
import { openNotificationWithIcon } from "../functions/notification";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import { decryptSingleData, encryptData } from "../functions/cryptojs";
import { google_map_key } from "../constants/mapkey";
import GoogleMapReact from "google-map-react";
import { CSVLink, CSVDownload } from "react-csv";

import startIcon from "../../assets/start.png";
import dest from "../../assets/dest.png";
import bike from "../../assets/bike.png";
import { todayDate } from "../functions/dateFunctions";
import Withdrawal_request from "../forms/withdrawal_request";

const token = sessionStorage.getItem("auth_token");
const { RangePicker } = DatePicker;
const { Option } = Select;

class Withdrawal extends Component {
  state = {
    selectedRowKeys: [],
    searchText: "",
    searchedColumn: "",
    load: true,
    data: [],
    list: [],
    chef: [],
    chef_selected: null,
    selected_date: todayDate(),
    start: null,
    end: null,
    selected: true,
    overall: true,
    allowed: false,
    blocked: false,
    driver_around: [],
    openModal: false,
    ride_selected: null,
    show: "all",
    rate: null,
    rate_view: false
  };

  componentDidMount() {
    this.getData();
  }

  static defaultProps = {
    center: {
      lat: 43.65107,
      lng: -79.347015
    },
    zoom: 5
  };

  getData = async () => {
    const request_details = {
      type: GET,
      url: service_api,
      route:
        "withdrawal" +
        "/" +
        "get-entity-partner-withdrawal/" +
        this.props.admin?._id,
      data: null,
      token: token
    };

    const request_details_orders = {
      type: GET,
      url: service_api,
      route: `order-glocery/get-glocery-completed-orders/${this.props.admin?._id}`,
      data: null,
      token: token
    };

    const response = await MakeRequestAsync(request_details).catch((err) => {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    });

    const response_order = await MakeRequestAsync(request_details_orders).catch(
      (err) => {
        // console.log("We couldn't fetch data: ", err?.response?.data?.message);
        return openNotificationWithIcon(
          "error",
          `${err?.response?.data?.message}`
        );
      }
    );

    this.setState({
      load: false,
      data: response?.data?.withdrawal,
      list: decryptSingleData(response_order?.data?.order)
    });
  };

  // handleStatus = async (id, status) => {
  //   const data = {
  //     status: status
  //   };
  //   const request_details = {
  //     type: UPDATE,
  //     url: service_api,
  //     route: "withdrawal" + "/" + "update-withdrawal" + "/" + id,
  //     data: data,
  //     token: token
  //   };

  //   const response = await MakeRequestAsync(request_details).catch((err) => {
  //     return openNotificationWithIcon("error", `${err.response.data}`);
  //   });
  //   return setTimeout(() => window.location.reload(), 1000);
  // };

  // handleDelete = async (id, status) => {
  //   const request_details = {
  //     type: DELETE,
  //     url: service_api,
  //     route: "withdrawal" + "/" + "delete" + "/" + id,
  //     data: null,
  //     token: token
  //   };

  //   const response = await MakeRequestAsync(request_details).catch((err) => {
  //     return openNotificationWithIcon("error", `${err.response.data}`);
  //   });
  //   return setTimeout(() => window.location.reload(), 1000);
  // };

  onSelectChange = (selectedRowKeys) => {
    console.log("selectedRowKeys changed: ", selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      )
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  // handleDelete = async (id) => {
  //   const request_details = {
  //     type: DELETE,
  //     url: service_api,
  //     route: order + "/" + delete_order + "/" + id,
  //     token: token
  //   };
  //   const response = await MakeRequestAsync(request_details).catch((err) => {
  //     return openNotificationWithIcon(
  //       "error",
  //       `${err?.response?.data?.message}`
  //     );
  //   });

  //   return setTimeout(() => window.location.reload(), 1000);
  // };

  render() {
    const columns = [
      // {
      //   title: "Id",
      //   dataIndex: "_id",
      //   // width: "20%",
      //   ...this.getColumnSearchProps("_id")
      //   // fixed: "left"
      // },
      // {
      //   title: "Image",
      //   dataIndex: "pic",
      //   render: (text, record) => (
      //     <a href={record?.entity_id?.pic1} target="_blank">
      //       <img
      //         src={record?.entity_id?.pic1}
      //         style={{
      //           width: 50,
      //           height: 50,
      //           objectFit: "contain"
      //         }}
      //         alt={"food-img"}
      //       />
      //     </a>
      //   )
      // },
      {
        title: "Montant",
        dataIndex: "amount",
        render: (text) => <Tag color={"volcano"}>{"$" + text}</Tag>
      },
      // {
      //   title: "Autres informations",
      //   dataIndex: "account_detail",
      //   render: (text, record) => (
      //     <Tag color="volcano">
      //       <span>Nom de banque: {text?.bank_name}</span>
      //       <br />
      //       <span>branch_code: {text?.branch_code}</span>
      //       <br />
      //       <span>Numéro de compte: {text?.account_number}</span>
      //       <br />
      //       <span>Intitulé de compte: {text?.account_name}</span>
      //     </Tag>
      //   )
      // },
      {
        title: "Status",
        dataIndex: "status",
        render: (text) => (
          <Tag color={text === 0 ? "orange" : text === 1 ? "green" : "volcano"}>
            <b>
              {text === 0 && "En attente"}
              {text === 1 && "Terminer"}
              {text === 2 && "Annuler"}
            </b>
          </Tag>
        )
      },
      {
        title: "Date/Time",
        dataIndex: "createdAt",
        render: (text) => (
          <span>{text?.slice(0, 10) + " " + text?.slice(11, 16)}</span>
        )
      }
      // {
      //   title: "Actions",
      //   fixed: "right",
      //   render: (text, record) => (
      //     <div>
      //       <Dropdown
      //         overlay={MenuButton(record)}
      //         placement="bottomCenter"
      //         arrow
      //       >
      //         <Button>Options</Button>
      //       </Dropdown>
      //     </div>
      //   )
      // }
    ];

    const { selectedRowKeys, allowed, blocked, overall } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      selections: [
        Table.SELECTION_ALL,
        Table.SELECTION_INVERT,
        Table.SELECTION_NONE,
        {
          key: "odd",
          text: "Select Odd Row",
          onSelect: (changableRowKeys) => {
            let newSelectedRowKeys = [];
            newSelectedRowKeys = changableRowKeys.filter((key, index) => {
              if (index % 2 !== 0) {
                return false;
              }
              return true;
            });
            this.setState({ selectedRowKeys: newSelectedRowKeys });
          }
        },
        {
          key: "even",
          text: "Select Even Row",
          onSelect: (changableRowKeys) => {
            let newSelectedRowKeys = [];
            newSelectedRowKeys = changableRowKeys.filter((key, index) => {
              if (index % 2 !== 0) {
                return true;
              }
              return false;
            });
            this.setState({ selectedRowKeys: newSelectedRowKeys });
          }
        }
      ]
    };

    const MenuButton = (record) => (
      <Menu>
        {/* <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 0)}>
            En attente
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 1)}>Terminer</Link>
        </Menu.Item>

        <Menu.Item>
          <Link onClick={() => this.handleStatus(record._id, 2)}>Rejeter</Link>
        </Menu.Item>

        <Menu.Item>
          <Link onClick={() => this.handleDelete(record._id)}>Supprimer</Link>
        </Menu.Item> */}
      </Menu>
    );

    const AnyReactComponent = ({ long, lat, path }) => (
      <div
        onClick={() => {
          this.setState({ openModal: true });
        }}
      >
        <img src={path} style={{ width: 50, height: 50 }} />
      </div>
    );

    const {
      load,
      data,
      list,
      selected,
      start,
      end,
      ride_selected,
      chef,
      chef_selected,
      selected_date
    } = this.state;
    return (
      <>
        <PageHeader
          onBack={() => {
            //  window.history.back()
          }}
          title="Withdrawals"
          tags={<Tag color="blue">My withdrawals</Tag>}
          subTitle=""
          extra={[
            <Withdrawal_request orders={list} withdrawals={data} />
            // <RangePicker
            //   showTime
            //   onChange={(data) => {
            //     console.log(data);
            //     if (data === null) {
            //       this.setState({
            //         start: null,
            //         end: null
            //       });
            //     }
            //     let d1 = data[0].format("YYYY-MM-DDTHH:mm:ss");
            //     let d2 = data[1].format("YYYY-MM-DDTHH:mm:ss");
            //     this.setState({ start: d1, end: d2 });
            //   }}
            // />
            // <CSVLink data={data}>Exporter CSV/Excel</CSVLink>
          ]}
        >
          <Row>
            <Statistic
              title="Total"
              value={
                data?.filter((item) => {
                  if (start === null || end === null) {
                    return item;
                  }
                  return item.createdAt >= start && item.createdAt <= end;
                }).length
              }
            />
          </Row>

          <Row gutter={16}>
            {!load && (
              <>
                <Col span={4}></Col>
              </>
            )}
          </Row>
          <Row
            style={{
              marginTop: 20
            }}
          >
            {load ? (
              <Space size="middle">
                <Spin size="large" />
              </Space>
            ) : (
              <Col span={24}>
                <Table
                  rowSelection={rowSelection}
                  // size="small"
                  scroll={{
                    x: "auto"
                  }}
                  columns={columns}
                  dataSource={data?.filter((item) => {
                    if (start === null || end === null) {
                      return item;
                    }
                    return item.createdAt >= start && item.createdAt <= end;
                  })}
                />
              </Col>
            )}
          </Row>
        </PageHeader>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    admin: state.admin
  };
};

const mapDispatchStoreToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchStoreToProps)(Withdrawal);
